<template>
    <div v-if="entry" class="card bs-4 p-0 pb-3">
        <h5 class="p-3 bb-1">Purchase Info</h5>
        <div class="row pl-3 pt-3 pr-5">
            <div class="col-1 label">Purchase ID</div>
            <div class="col-2 p-1 b-1 text-muted round-1">{{ entry.entry_id }}</div>
            <div class="col-1"/>

            <div class="col-1 label">Vendor</div>
            <div class="col-2 p-1 b-1 text-muted round-1">{{ entry.vendor }}</div>
            <div class="col-1"/>

            <div class="col-1 label">Date</div>
            <div class="col-2 p-1 b-1 text-muted round-1">{{ entry.date }}</div>
            <div class="col-1"/>
        </div>
        <div class="row pl-3 pt-3 pr-5">
            <div class="col-1 label">Status</div>
            <div class="col-2 p-1 b-1 text-muted round-1">{{ entry.status }}</div>
            <div class="col-1"/>

            <div class="col-1 label">Created By</div>
            <div class="col-2 p-1 b-1 text-muted round-1">{{ entry.created_by }}</div>
            <div class="col-1"/>

            <div v-if="entry.remarks" class="col-1 label">Remarks</div>
            <div v-if="entry.remarks" class="col-2 p-1 b-1 text-muted round-1">{{ entry.remarks }}</div>
            <div v-if="entry.remarks" class="col-1"/>
        </div>
        <custom-simple-table class="table-borderless mt-4 mb-0" v-if="entry.items" ref="table" title="Items"
                             :fields="fields" :data="entry.items">
            <template #no="rowData">
                <span>{{ getSlNo(rowData.rowData, entry.items) }}</span>
            </template>
        </custom-simple-table>
    </div>

</template>

<script>
export default {
    props : {
        entry : { type : Object }
    },
    name : 'PurchaseEntryDetailsTable',
    data () {
        return {
            DataLoading : false,
            fields      : [
                {
                    name      : '__slot:no',
                    sortField : 'no',
                    title     : 'Sl No'
                },
                {
                    name      : 'product',
                    sortField : 'product',
                    title     : 'Item'
                },
                {
                    name      : 'price',
                    sortField : 'price',
                    title     : 'Price'
                },
                {
                    name      : 'quantity',
                    sortField : 'quantity',
                    title     : 'Quantity'
                },
                {
                    name      : 'sub_total',
                    sortField : 'sub_total',
                    title     : 'Sub Total'
                },
                {
                    name      : 'tax',
                    sortField : 'tax',
                    title     : 'Tax'
                },
                {
                    name      : 'total',
                    sortField : 'total',
                    title     : 'Total'
                }
            ]
        };
    },
    methods : {
        getSlNo (rowData, items) {
            for (let i = 0; i <= items.length; i++) {
                if (items[i].id === rowData.id) {
                    return i + 1;
                }
            }
        }
    }
};
</script>

<style scoped>
.label {
    font-weight: 500;
}
</style>
